import cn from "classnames";
import { Field } from "react-final-form";
import { Select, Divider } from "antd";
import styles from "./PaymentMethodsSelectField.module.scss";
import { ERROR_FIELD_, URL_TARIF } from "~/configs/consts";
import { useIsMobile } from "~/hooks";
import { composeValidators, disabledValidate } from "~/utils";
import { validateArrayNotEmpty } from "~/utils/validate";
import { ErrorField } from "~/components";
import { Checkbox } from "~/components/checkbox-field";

interface OptionPaymentMethod {
  name: string;
  title: string;
  isEnabled: boolean;
  descriptionHowToEnable?: string;
  isShow: boolean;
}

interface PaymentMethodsSelectFieldProps {
  name: string;
  titleField?: string;
  options: Record<string, OptionPaymentMethod>;
  required?: boolean;
  maxSelected?: number;
}

const getShortTitle = (fullTitle: string): string => {
  const shortTitles: Record<string, string> = {
    'Зарубежные оплаты - формирование ссылки в рублях/тенге/евро/долларах (Банковские карты, выпущенные за пределами РФ)': 'Зарубежные оплаты',
    'Российские оплаты (Карты РФ, оплата по счётам для ООО и ИП, Сбербанк - онлайн)': 'Российские оплаты',
    'Рассрочки и кредиты (ОТП, СБЕР, Хоум Банк, Т-Банк, Фреш Кредит)': 'Рассрочки и кредиты',
    'Рассрочки для граждан Казахстана (ФридомБанк)': 'Рассрочки для граждан Казахстана',
  };

  return shortTitles[fullTitle] || fullTitle;
};

export const PaymentMethodsSelectField = ({
  name,
  titleField,
  options,
  required,
  maxSelected = 4,
}: PaymentMethodsSelectFieldProps) => {
  const isMobile = useIsMobile();

  const renderSelect = (
    input: any,
    inputId?: string
  ) => {
    const toggleOption = (key: string) => {
      const current = input.value || [];

      if (current.includes(key)) {
        if (current.length > 1) {
          input.onChange(current.filter((v: string) => v !== key));
        }
      } else {
        if (!maxSelected || current.length < maxSelected) {
          input.onChange([...current, key]);
        }
      }
    };


    const selectComponent = (
      <Select
        id={inputId}
        className="custom-select"
        value={null}
        placeholder={
          <div style={{ display: "flex", alignItems: "center" }}>
            <span
              style={{ marginRight: "auto" }}
              className={cn({
                [styles.text]: required,
              })}
            >
              {titleField}
            </span>
          </div>
        }
        placement="bottomLeft"
        style={{ width: "100%", height: 56, borderRadius: 12 }}
        dropdownRender={(menu) => (
          <>
            <div className={styles.conteinerDescriptionPaymentMethods}>
              <p className={styles.descriptionPaymentMethods}>
                С подробным описанием методов оплат с вознаграждением системы, вы можете
                ознакомиться{" "}
                <a
                  href={URL_TARIF}
                  target="_blank"
                  className={styles.textBlueLink}
                  rel="noopener noreferrer"
                >
                  здесь
                </a>
                .
              </p>
              <p className={styles.descriptionPaymentMethods}>
                Если вам нужны международные платежи или рассрочки от других банков, вы сможете подключить их позже через техподдержку
              </p>
            </div>

            <Divider style={{ margin: "0px 0px 12px" }} />

            <div
              className={styles.containerOptions}
              style={{
                maxHeight: isMobile ? 240 : 300,
                overflowY: "auto",
                paddingRight: 8,
              }}
            >
              {options &&
                Object.entries(options)
                  // .filter(([_, o]) => o.isShow)
                  .map(([key, option]) => (
                    <div key={key} className={styles.optionRow}>
                      <label
                        className={cn(styles.option, {
                          [styles.disabled]: !option.isEnabled,
                        })}
                      >
                        <Checkbox
                          checked={input.value?.includes(key)}
                          onChange={() => toggleOption(key)}
                          labelClassName={styles.checkboxlabelClassName}
                          indicatorClassName={styles.indicatorClassName}
                        >
                          {option.title}
                        </Checkbox>
                      </label>
                    </div>
                  ))}
            </div>
          </>
        )}
      />
    );

    return selectComponent
  };

  return (
    <div>
      <Field
        name={name}
        subscription={{
          submitFailed: true,
          error: true,
          submitError: true,
          value: true,
        }}
        validate={disabledValidate(composeValidators(validateArrayNotEmpty('Обязательно для заполнения')))}
      >
        {({ input, meta: { submitFailed, error, submitError } }) => {
          const hasError = (error || submitError) && submitFailed;
          const inputId = hasError ? `${ERROR_FIELD_ + input.name}` : undefined;

          return (
            <>
              {renderSelect(input, inputId)}

              {input.value && input.value.length > 0 && (
                <div className={styles.selectedMethodsContainer}>
                  {input.value.map((key: string) => {
                    const option = options[key];
                    if (!option) return null;

                    const shortTitle = getShortTitle(option.title);

                    return (
                      <div key={key} className={styles.methodChip}>
                        <span className={styles.methodChipText} title={option.title}>
                          {shortTitle}
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </>
          );
        }}
      </Field>
      <ErrorField name={name} />
    </div>
  );
};
